import { ApplicantType } from "shared/types/application";
import { ManualOption, SelfServeOption } from "./types";

const sameEmail = (a?: string | null, b?: string | null) =>
  Boolean(a?.trim()) && a?.trim().toLowerCase() === b?.trim().toLowerCase();

const hasEmail = (
  option: SelfServeOption | ManualOption
): option is SelfServeOption =>
  option.type === "self-serve" && Boolean(option.email?.trim());

export const inviteeLeadIds = (
  options: (SelfServeOption | ManualOption)[],
  leadId?: number,
  leadPrimaryEmail?: string | null,
  applicationId?: number
): (number | undefined)[] => {
  if (!leadId) return options.map(() => undefined);

  const isLeadContact = options.map(
    (option) => hasEmail(option) && sameEmail(option.email, leadPrimaryEmail)
  );
  if (isLeadContact.some(Boolean))
    return isLeadContact.map((matches) => (matches ? leadId : undefined));
  if (applicationId) return options.map(() => undefined);

  const firstApplicantIdx = options.findIndex(
    (option) => hasEmail(option) && option.role === ApplicantType.Applicant
  );
  return options.map((_, idx) =>
    idx === firstApplicantIdx ? leadId : undefined
  );
};
